import { render, staticRenderFns } from "./ExportsTab.vue?vue&type=template&id=25783130&scoped=true&"
import script from "./ExportsTab.vue?vue&type=script&lang=js&"
export * from "./ExportsTab.vue?vue&type=script&lang=js&"
import style0 from "./ExportsTab.vue?vue&type=style&index=0&id=25783130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25783130",
  null
  
)

export default component.exports